module.exports = __webpack_public_path__ + "static/portfolio-4-e2ebc9bd6cb17f9afba40dc2c8e5a3e5.jpg";